export default {
	noEvents: "Aucun événement trouvé",
	noEventsDescription: "Il n'y a aucun événement à afficher dans cette chronologie",
};
